import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycorporatecabrentalinchennai() {



  const cardData =
  {
    keyword: 'Monthly Corporate Cab Rental in Chennai',
    heading: 'Aaryan Travels: Monthly Corporate Cab Rental in Chennai',
    headingDescription: ' Aaryan Travels offers reliable Monthly Corporate Cab Rental in Chennai for companies, executives, and employees who require consistent transportation without the hassle of daily bookings. Whether it’s employee commute, client transfers, airport pickups from Chennai International Airport, or intercity travel to Bengaluru or Coimbatore, our fleet of sedans, SUVs, and tempo travellers is available on structured monthly packages. With trained chauffeurs, GPS-enabled vehicles, punctual reporting, and transparent billing, we provide seamless corporate mobility across major business zones like OMR, Guindy, Ambattur, and Siruseri. Aaryan Travels ensures professionalism and cost-efficiency with well-managed monthly corporate cab rental solutions in Chennai.',

    top: 'Top Places to Visit in Chennai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is the longest natural urban beach in India, stretching over 13 km along the Bay of Bengal. It is a favorite spot for morning walks, sunsets, and street food like sundal and murukku. Fishermen boats, lighthouse views, and cool sea breeze make it iconic. Statues and memorials along the promenade add cultural charm. Marina Beach is Chennai’s vibrant coastal jewel."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a stunning example of Dravidian architecture dedicated to Lord Shiva. Its colorful gopurams, intricate carvings, and sacred pond attract thousands of devotees. The temple bursts with energy during festivals like Panguni Peruvizha. Traditional markets and flower shops surround the complex. Kapaleeshwarar Temple is Chennai’s spiritual and architectural masterpiece."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, built in 1644 by the British East India Company, is the first English fortress in India. It now houses the Tamil Nadu Legislative Assembly and a museum showcasing colonial-era weapons, documents, and artifacts. St. Mary’s Church inside is one of the oldest surviving Anglican churches in Asia. Fort St. George is Chennai’s historic milestone of British legacy."
  },
  {
    "title": "Santhome Basilica",
    "description": "Santhome Basilica is a majestic Roman Catholic church built over the tomb of Saint Thomas the Apostle. Its neo-Gothic architecture and stained-glass windows draw visitors from across the world. A small underground chapel preserves the apostle’s relics. The serene interiors offer peace and reflection. Santhome Basilica is Chennai’s sacred connection to global Christianity."
  },
  {
    "title": "Vivekananda House",
    "description": "Vivekananda House, also known as the Ice House, is a historic landmark where Swami Vivekananda stayed in 1897. It has been converted into a museum showcasing his life and teachings through multimedia exhibits. The meditation room inspires visitors to seek inner peace. Overlooking Marina Beach, it offers scenic views. Vivekananda House is Chennai’s beacon of spiritual wisdom."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of India’s smallest yet most diverse urban national parks. It is home to blackbucks, spotted deer, jackals, and hundreds of bird species. The adjoining Children’s Park and Snake Park are popular among families. Nature lovers enjoy shaded walking trails and calm surroundings. Guindy National Park is Chennai’s refreshing green sanctuary."
  },
  {
    "title": "Elliot’s Beach (Besant Nagar Beach)",
    "description": "Elliot’s Beach, located in Besant Nagar, offers a quieter alternative to Marina Beach. It is popular among youngsters for its cafés, sunrise views, and relaxed ambiance. The nearby Ashtalakshmi Temple and Karl Schmidt Memorial add cultural beauty. Nighttime walks under streetlights are especially charming. Elliot’s Beach is Chennai’s soothing seaside retreat."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a grand memorial built in honor of the revered Tamil poet-saint Thiruvalluvar. The monument features a 39-meter-high stone chariot and a massive auditorium. Its walls are inscribed with all 1,330 couplets from his famous work, the Thirukkural. Cultural programs and exhibitions are frequently held here. Valluvar Kottam is Chennai’s tribute to Tamil literature."
  },
  {
    "title": "Express Avenue Mall",
    "description": "Express Avenue is Chennai’s most popular shopping and entertainment mall, offering premium brands, restaurants, and South India’s largest gaming zone. The luxury multiplex and food court make it a perfect hangout spot for families and friends. Its vibrant atmosphere reflects Chennai’s modern lifestyle. Express Avenue Mall is the city’s hub for fashion and fun."
  },
  {
    "title": "Arignar Anna Zoological Park (Vandalur Zoo)",
    "description": "Located on the outskirts of Chennai, Vandalur Zoo is India’s largest zoological park spread across 1,500 acres. It houses over 2,500 animals including lions, tigers, elephants, and rare species. Safari rides, butterfly parks, and reptile houses attract nature enthusiasts. The lush greenery makes it an ideal family day-out destination. Vandalur Zoo is Chennai’s vast wildlife adventure zone."
  }
],


"services": [
  {
    "name": "Monthly Corporate Cab Rental in Chennai",
    "description": "Our Monthly Corporate Cab Rental service in Chennai is tailored for businesses that require consistent and professional transportation for their teams. With fixed monthly rates, dedicated vehicles, and fully managed driver support, this service is ideal for companies looking to streamline employee commutes, executive transport, or client mobility. We offer fleet flexibility, real-time tracking, and centralized billing to make long-term travel planning easy and efficient."
  },
  {
    "name": "Chennai Monthly Cab Hire",
    "description": "Chennai Monthly Cab Hire provides flexible cab rental solutions for organizations that need daily transportation over extended durations. Whether it’s for office staff, field executives, or daily inter-office travel, our service ensures comfortable, punctual, and hassle-free rides. Our packages can be tailored to suit your route, shift, and vehicle requirements, with dedicated support and transparent invoicing."
  },
  {
    "name": "Corporate Taxi Rental Chennai",
    "description": "Corporate Taxi Rental in Chennai offers business-grade cab services on a rental basis for daily use, business travel, and employee commutes. Featuring clean vehicles, professional chauffeurs, and flexible contracts, our taxi rentals are perfect for companies seeking reliable, cost-effective ground transport without the complications of owning a fleet."
  },
  {
    "name": "Long Term Business Cab Chennai",
    "description": "Our Long Term Business Cab service in Chennai is designed for enterprises that need dependable and consistent transport over weeks or months. We offer customizable plans with options to choose between sedans, SUVs, and premium vehicles, ensuring the right fit for your business needs. This service includes fixed-driver assignments, vehicle maintenance, and monthly billing reports."
  },
  {
    "name": "Chauffeur Corporate Cab Chennai",
    "description": "Travel in comfort and professionalism with our Chauffeur-driven Corporate Cab service in Chennai. Ideal for executives, senior staff, and business visitors, this service includes trained chauffeurs, luxury vehicles, and flexible scheduling. Perfect for daily office commutes, meetings, or airport transfers, all managed under corporate billing."
  },
  {
    "name": "Affordable Monthly Cab Chennai",
    "description": "Looking for cost-effective monthly transport? Our Affordable Monthly Cab service in Chennai is perfect for startups, SMEs, and expanding teams. Get budget-friendly rates without compromising on comfort, safety, or professionalism. Our cabs are regularly maintained and driven by experienced chauffeurs, ensuring smooth rides every day."
  },
  {
    "name": "Employee Transport Cab Chennai",
    "description": "Ensure safe and timely commuting for your staff with our Employee Transport Cab service in Chennai. This monthly rental solution covers multiple shifts, group pickups, and custom routes, making it suitable for IT companies, manufacturing units, and BPOs. Includes route optimization, GPS tracking, and emergency support to ensure seamless daily operations."
  },
  {
    "name": "Staff Cab Service Chennai",
    "description": "Our Staff Cab Service in Chennai offers reliable cab transportation for your employees on a monthly basis. Ideal for daily pick-up and drop-off services, we provide multi-seater vehicles and sedans based on company size and shift timing. Enjoy complete peace of mind with background-verified drivers, live tracking, and real-time support."
  },
  {
    "name": "Office Cab Monthly Chennai",
    "description": "Office Cab Monthly plans in Chennai help companies manage recurring employee travel with fixed, predictable costs. Whether you need a single cab or an entire fleet, our solution includes professional drivers, route planning, maintenance, and round-the-clock assistance, making corporate mobility easy and stress-free."
  },
  {
    "name": "Premium Business Cab Chennai",
    "description": "Our Premium Business Cab service in Chennai is ideal for high-ranking executives or special clients. With luxury sedans, discreet chauffeurs, and premium service standards, we ensure a first-class experience for daily or long-term use. This plan includes flexible scheduling, priority support, and top-tier vehicle options."
  },
  {
    "name": "Sedan Monthly Rental Chennai",
    "description": "Choose our Sedan Monthly Rental service in Chennai for professional, comfortable travel across the city. Ideal for single executives or small teams, our sedans are equipped with air-conditioning, clean interiors, and experienced chauffeurs. This long-term solution is perfect for daily commutes, client visits, and local corporate errands."
  },
  {
    "name": "SUV Monthly Corporate Hire Chennai",
    "description": "For larger teams or executives needing extra space, our SUV Monthly Corporate Hire in Chennai is the ideal option. With roomy interiors, powerful engines, and smooth suspension, these vehicles are perfect for long commutes or outstation travel. Available on monthly contracts with trained drivers and fuel options."
  },
  {
    "name": "Corporate Travel Cab Chennai",
    "description": "Corporate Travel Cab services in Chennai cover all your ground transport needs – from daily commutes and airport transfers to client meetings and intercity rides. Offered on a monthly rental basis, our fleet includes sedans, SUVs, and executive cars, all operated by professional drivers under a corporate service model."
  },
  {
    "name": "Chennai Company Cab",
    "description": "Our Chennai Company Cab service provides companies with dedicated cabs for long-term travel needs. Ideal for startups to large enterprises, we offer multi-cab arrangements, professional drivers, and fleet tracking for better travel management. Choose this service for an efficient and dependable employee transportation strategy."
  },
  {
    "name": "Monthly Taxi Booking Chennai",
    "description": "Monthly Taxi Booking in Chennai makes recurring cab needs simple. With a single monthly plan, you get access to verified drivers, clean vehicles, daily reporting, and 24/7 support. This service is ideal for corporates, educational institutions, and organizations with regular transport needs for staff or guests."
  }
],
"tableData": [
  ["Monthly Corporate Cab Rental in Chennai", "Chennai Monthly Cab Hire"],
  ["Corporate Taxi Rental Chennai", "Long Term Business Cab Chennai"],
  ["Chauffeur Corporate Cab Chennai", "Affordable Monthly Cab Chennai"],
  ["Employee Transport Cab Chennai", "Staff Cab Service Chennai"],
  ["Office Cab Monthly Chennai", "Premium Business Cab Chennai"],
  ["Sedan Monthly Rental Chennai", "SUV Monthly Corporate Hire Chennai"],
  ["Corporate Travel Cab Chennai", "Chennai Company Cab"],
  ["Monthly Taxi Booking Chennai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Dependable Monthly Corporate Cab Rental in Chennai",
    "WhyChoosedescription": "Aaryan Travels offers flexible and reliable monthly corporate cab rentals tailored to Chennai’s business needs."
  },
  {
    "WhyChooseheading": "Consistent and Punctual Daily Service",
    "WhyChoosedescription": "Ensure timely pickups and drops for your employees every day throughout the contract period."
  },
  {
    "WhyChooseheading": "Well-Maintained, Comfortable Business-Class Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars designed for comfort and professionalism."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Chennai’s Corporate Routes",
    "WhyChoosedescription": "Our drivers know the city’s business hubs and traffic patterns for efficient travel."
  },
  {
    "WhyChooseheading": "Transparent Monthly Pricing with No Hidden Charges",
    "WhyChoosedescription": "Get upfront, all-inclusive pricing covering fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Seamless Coordination",
    "WhyChoosedescription": "Our support team is available round the clock to assist with scheduling and any adjustments."
  },
  {
    "WhyChooseheading": "Flexible Contract Terms to Suit Your Business Needs",
    "WhyChoosedescription": "Choose daily, weekly, or monthly contracts customized for your organization."
  },
  {
    "WhyChooseheading": "Wide Vehicle Selection for Individual and Group Travel",
    "WhyChoosedescription": "Select from sedans, SUVs, or larger vehicles based on your team size and comfort preferences."
  }
]






















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly corporate cab rental services in Chennai?',
    answer: 'Yes, Aaryan Travels provides flexible and reliable monthly corporate cab rental solutions in Chennai.',
  },
  {
    question: 'How can I book a monthly corporate cab rental in Chennai with Aaryan Travels?',
    answer: 'You can easily book monthly corporate cabs through our website, mobile app, or by contacting our corporate support team.',
  },
  {
    question: 'What types of vehicles are available for monthly corporate cab rentals in Chennai?',
    answer: 'Aaryan Travels offers a wide range of vehicles including sedans, SUVs, and premium cars suitable for corporate use.',
  },
  {
    question: 'Are monthly corporate cab rentals suitable for daily employee commute in Chennai?',
    answer: 'Yes, our monthly rental packages are ideal for daily employee pickups and drops across Chennai.',
  },
  {
    question: 'Are drivers trained and experienced for corporate cab rentals in Chennai?',
    answer: 'Absolutely. Our drivers are professional, punctual, and familiar with Chennai’s corporate travel requirements.',
  },
  {
    question: 'Do you offer customized monthly cab rental plans for corporate clients in Chennai?',
    answer: 'Yes, we tailor monthly rental plans to fit your company’s specific transportation needs.',
  },
  {
    question: 'Is monthly corporate cab rental service available 24x7 in Chennai?',
    answer: 'Yes, Aaryan Travels provides round-the-clock monthly corporate cab services in Chennai.',
  },
  {
    question: 'What safety protocols are followed for monthly corporate cab rentals in Chennai?',
    answer: 'All vehicles are regularly sanitized and our drivers follow strict safety and hygiene measures.',
  },
  {
    question: 'Do you provide monthly billing and invoicing for corporate cab rentals in Chennai?',
    answer: 'Yes, we offer flexible monthly billing options and GST-compliant invoicing for corporate clients.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for monthly corporate cab rentals in Chennai?',
    answer: 'Yes, Aaryan Travels allows full customization of pickup and drop points as per your corporate travel requirements.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arvind Kumar',
    feedback: 'Aaryan Travels’ monthly corporate cab rental in Chennai has been a great solution for our employee transportation needs.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Reddy',
    feedback: 'Reliable and efficient monthly corporate cab services by Aaryan Travels in Chennai. Highly recommend!',
    rating: 5,
  },
];





















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Corporate Cab Rental in Chennai",
  "image": "https://aaryantravels.com/assets/images/monthly-corporate-cab-chennai.jpg", // replace with actual image URL
  "description": "Flexible and affordable monthly corporate cab rental services in Chennai by Aaryan Travels. Ideal for employee transport, business travel, and long-term corporate cab hire with sedan and SUV options.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update as needed
    "ratingCount": "3100", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "16000",  // example monthly price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/monthly-corporate-cab-rental-chennai"
  }
};







  return (
    <div>
<Helmet>
  <title>Monthly Corporate Cab Rental in Chennai | Long-Term Business Cab | Aaryan Travels</title>
  <meta
    name="description"
    content="Flexible and affordable monthly corporate cab rental services in Chennai by Aaryan Travels. Ideal for employee transport, business travel, and long-term corporate cab hire with sedan and SUV options."
  />
  <meta
    name="keywords"
    content="Monthly Corporate Cab Rental in Chennai, Chennai Monthly Cab Hire, Corporate Taxi Rental Chennai, Long Term Business Cab Chennai, Chauffeur Corporate Cab Chennai, Affordable Monthly Cab Chennai, Employee Transport Cab Chennai, Staff Cab Service Chennai, Office Cab Monthly Chennai, Premium Business Cab Chennai, Sedan Monthly Rental Chennai, SUV Monthly Corporate Hire Chennai, Corporate Travel Cab Chennai, Chennai Company Cab, Monthly Taxi Booking Chennai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycorporatecabrentalinchennai;